import { memo } from "preact/compat";
import EjLogo from "../../assets/ej-logo.svg";

export const ComingSoon = memo(() => {
  return (
    <div
      className="fixed inset-0 bg-cover bg-no-repeat bg-center flex flex-col min-h-[100dvh] w-full items-center overflow-auto bg-gray-950"
      style={{
        backgroundImage: `url(${""})`,
      }}
    >
      <div className="p-8 h-full flex items-center md:justify-between gap-8 w-full max-w-7xl mx-auto overflow-auto md:flex-row flex-col">
        <div className="flex flex-col items-start justify-between md:h-full w-full">
          <div className="hidden md:block"></div>
          <div className="flex flex-col items-start gap-9 2xl:gap-12">
            <img src="" alt="Logo" />
            <img src="" alt="Lockup" className="max-w-full w-[500px]" />
          </div>
          <div className="md:flex hidden bottom-4 w-full ">
            <div className="flex items-center justify-center gap-8 ">
              <img src={EjLogo} alt="EyeJack" className="h-[18px]" />
              <img src="" alt="Logo" />
              <img src="" alt="Logo" />
            </div>
          </div>
        </div>

        <div className="flex-grow flex md:flex-row flex-col justify-center w-full items-center gap-12">
          <div className="flex-grow w-full flex flex-col items-center justify-center gap-6 h-full">
            <span className="font-bold text-3xl text-center tracking-[1px]">
              COMING SOON
            </span>
            <h2 className="text-white text-center text-2xl leading-[20.7px] font-secondary-sans-light tracking-[-0.41px]">
              1 May 2025
            </h2>
          </div>
          <div className="w-full md:hidden flex items-center justify-center ">
            <div className="flex items-center justify-center gap-8 ">
              <img src={EjLogo} alt="EyeJack" />
              <img src="" alt="Logo" />
              <img src="" alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ComingSoon;
